import { render, staticRenderFns } from "./FooterColumn.vue?vue&type=template&id=99bd09dc&scoped=true&"
import script from "./FooterColumn.vue?vue&type=script&lang=ts&"
export * from "./FooterColumn.vue?vue&type=script&lang=ts&"
import style0 from "./FooterColumn.vue?vue&type=style&index=0&id=99bd09dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bd09dc",
  null
  
)

export default component.exports